function persistFinishedDetail(storage, detail) {
  storage.setItem('gameOverData', JSON.stringify(detail));
  storage.removeItem('gameId');
  storage.setItem('currentScreen', 'gameOver');
}

module.exports = { persistFinishedDetail };
